<template>
  <div>
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-r">{{ getParentRegionName() }} - Mapa strony</h2>
    <a-row>
      <a-col>
        <div class="content-pane content-pane_white mb-48">
          <a-row :gutter="16" type="flex">
            <a-col :md="12">
              <!--<h4 class="c-blue-dark mb-12">
                {{ getParentRegionName() }} - wycieczki
              </h4>
              <ul class="column-list mb-24">
                <li>
                  <span class="arrow-right"></span
                  ><a href="/" title="Strona główna">Strona główna</a>
                </li>
                <li v-for="({ tytul, link }, idx) in frontlinki" :key="idx">
                  <span class="arrow-right"></span
                  ><a :href="link" :title="tytul">{{ tytul }}</a>
                </li>
              </ul>
              <h4 class="c-blue-dark mb-12">
                {{ getParentRegionName() }} - przewodniki
              </h4>
              <ul class="column-list mb-24">
                <li>
                  <span class="arrow-right"></span
                  ><a :href="getGuidePageUrl()" :title="getGuidePageTitle()">{{
                    getGuidePageTitle()
                  }}</a>
                </li>
                <li
                  v-for="({ name, url }, idx) in geostruct.geotree.Country
                    .Region"
                  :key="idx"
                >
                  <span class="arrow-right"></span
                  ><a :href="url" :title="name">{{ name }}</a>
                </li>
              </ul>
              <h4 class="c-blue-dark mb-12">
                {{ getParentRegionName() }} - rodzaje wczasów
              </h4>
              <ul class="column-list mb-24">
                <li v-for="(item, idx) in getOferty()" :key="idx">
                  <span class="arrow-right"></span>
                  <template v-if="item.child.pnazwa != ''">
                    <a :href="item.url" :title="item.child.pnazwa">{{
                      item.child.pnazwa
                    }}</a>
                  </template>
                  <template v-else>
                    <a :href="item.url" title="Wszystkie kategorie"
                      >Wszystkie kategorie</a
                    >
                  </template>
                </li>
	      </ul>-->
            </a-col>
            <a-col :md="12">
              <!--<h4 class="c-blue-dark mb-12">
                {{ getParentRegionName() }} - wczasy wg regionów
              </h4>
              <ul class="column-list mb-24">
                <li v-for="({ nazwa, url }, idx) in topregiony" :key="idx">
                  <span class="arrow-right"></span
                  ><a :href="getRegionUrl(url)" :title="nazwa">{{ nazwa }}</a>
                </li>
              </ul>

              <h4 class="c-blue-dark mb-12">Lista hoteli</h4>
              <ul class="column-list mb-24">
                <li>
                  <span class="arrow-right"></span>
                  <a href="lista-hoteli.xml" title="Lista hoteli"
                    >Lista hoteli</a
                  >
                </li>
              </ul>
              <h4 class="c-blue-dark mb-12">Pogoda i klimat</h4>
              <ul class="column-list mb-24">
                <li>
                  <span class="arrow-right"></span>
                  <a href="pogoda-klimat.xml" title="Pogoda i klimat"
                    >Pogoda i klimat</a
                  >
                </li>
	      </ul>-->
              <h4 class="c-blue-dark mb-12">Portale turystyczne</h4>
              <ul class="column-list mb-24">
                <li>
                  <span class="arrow-right"></span>
                  <a
                    href="portale-turystyczne.xml"
                    title="Lista portali turystycznych"
                    >Lista portali turystycznych</a
                  >
                </li>
              </ul>
              <h4 class="c-blue-dark mb-12">Informacje</h4>
              <ul class="column-list mb-24">
                <li>
                  <span class="arrow-right"></span
                  ><a href="o-nas" title="O nas">O nas</a>
                </li>
                <li>
                  <span class="arrow-right"></span
                  ><a href="kontakt" title="Kontakt">Kontakt</a>
                </li>
                <li>
                  <span class="arrow-right"></span
                  ><a href="regulamin" title="Regulamin">Regulamin</a>
                </li>
                <li>
                  <span class="arrow-right"></span>
                  <a href="polityka-prywatnosci" title="Polityka prywatności"
                    >Polityka prywatności</a
                  >
                </li>
              </ul>
            </a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import * as CONFIG from "./config.js";
import * as FRONTLINKI from "./frontlinki.js";
import * as GEOSTRUCTURE from "../../geotree.js";
import * as TOPREGIONY from "./topregiony.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";

export default {
  name: "mapa-serwisu-content",
  data: () => ({
    url: "/getrodzajoferty.xml",
    frontlinki: FRONTLINKI.frontlinki.items,
    geostruct: GEOSTRUCTURE.geostruktura,
    topregiony: TOPREGIONY.topregiony.regiony.item,
    disabled: ["lato2016", "lato2017", "lato2018", "lato2019", "lato2020"],
    rodzajeOfert: []
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({
        name: "Mapa serwisu",
        link: ""
      });
      return crumbsArr;
    },
    getParentRegionName() {
      return CONFIG.panstwo_nazwapl;
    },
    getGuidePageTitle() {
      return CONFIG.panstwo_nazwapl + " - przewodnik turystyczny";
    },
    getGuidePageUrl() {
      return "/" + CONFIG.panstwo_id + "-przewodnik-turystyczny.xml";
    },
    getRegionUrl(url) {
      if (url.indexOf("www.") !== -1) {
        var index = url.indexOf(".pl/");
        return url.substring(index + 4);
      } else {
        return url;
      }
    },
    getOferty() {
      var that = this;
      return this.rodzajeOfert.filter(function(elem, index) {
        if (that.disabled.includes(elem.child.nazwa)) {
          return false;
        } else {
          return true;
        }
      });
    },
    getRodzajOfertyData() {
      var that = this;
      var rodzajUrl = CONFIG.API_URL + this.url;
      var result = jQuery.ajax({
        url: rodzajUrl,
        dataType: "xml",
        crossDomain: true,
        method: "GET",
        success: function(data) {
          var xmlObj = jQuery(data);
          var arr = [];
          xmlObj.find("item").each(function(index) {
            var newObj = {};
            newObj.url = jQuery(this).attr("url");
            var subObj = {};
            subObj.prefix = jQuery(this)
              .find("prefix")
              .text();
            subObj.nazwa = jQuery(this)
              .find("nazwa")
              .text();
            subObj.pnazwa = jQuery(this)
              .find("pnazwa")
              .text();
            subObj.snazwa = jQuery(this)
              .find("snazwa")
              .text();
            newObj.child = subObj;
            arr.push(newObj);
          });
          that.rodzajeOfert = arr;
        },
        error: function(e) {
          console.log(e);
          console.log("Ajax Error");
        }
      });
      return result;
    }
  },
  mounted() {
    this.getRodzajOfertyData();
  },
  components: {
    T1Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.column-list {
  list-style-type: none;
  padding: 0;

  > li {
    padding: 2px 6px 2px 16px;
    position: relative;

    a {
      color: $text-color-default;

      &:focus,
      &:hover {
        color: $blue-light;
      }
    }
  }
}

.arrow-right {
  border: solid $gray-40;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 10px;
  transform: rotate(-45deg);
}
</style>
